import React, { useEffect } from "react";

const Select = ({ label, handlechange, value , options }) => {
  // Function to handle  state



  return (
    <div className="w-full flex flex-col ">
      <label className="text-sm font-semibold mb-[11px]">{label}</label>
      <select
        id="states"
        value={value}
        onChange={handlechange}
        className=" form-select appearance-none bg-no-repeat  w-full  bg-white rounded-md py-2 px-3  border border-[#e0e0e0]"
      >
        {options &&
          options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
    </div>
  );
};

export default Select;
